import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  mdxEditor: {
    '.cm-richView': {
      minHeight: '20vh'
    }
  },
  error: {
    borderColor: theme.vars.palette.error.main
  }
}));

export default useStyles;
